<div class="configuration-modal flex flex-col h-full">

    <mat-dialog-content>
        <div class="config-tab flex flex-col h-full">
            <div class="flex flex-row w-full items-center">
                <h3 class="text-lg font-medium">Priorisation par technologie : FTTH</h3>
            </div>
            <!-- <ng-select
                class="mt-2"
                bindLabel="name"
                [clearable]="true"
                [(ngModel)]="toBeAddedTechnology"
                [placeholder]="'Sélectionner une technologie à prioriser'"
                [items]="[
                    {name: 'FTTO', technology: 'FTTO', provider: 'Orange', offer: 'Access'}, 
                    {name: 'FTTE', technology: 'FTTE', provider: 'Orange', offer: 'Access'}, 
                    {name: 'FTTH', technology: 'FTTH', provider: 'Covage', offer: 'BPE'}
                ]">
            </ng-select>
            <button class="mt-2" mat-stroked-button [disabled]="!selectedAccess() || !toBeAddedTechnology()" (click)="addTechnology()">Ajouter</button> -->
            <ag-grid-angular
                class="mt-2 grid-dimensions"
                [columnDefs]="columns"
                [rowData]="rowData"
                [rowDragManaged]="true"
                [autoSizeStrategy]="{type: 'fitGridWidth'}"
            />
        </div>
    </mat-dialog-content>  

    <mat-dialog-actions align="end">
        <button mat-stroked-button [mat-dialog-close]>Annuler</button>
        <button mat-stroked-button>Rétablir la priorisation par défaut</button>
        <button mat-stroked-button>Sauvegarder</button>
    </mat-dialog-actions>
</div>